import classNames from 'classnames';

import styles from './styles.module.scss';

const TabContent = ({ children, active, className, ...restProps }) => {
  if (!active) {
    return null;
  }
  return (
    <div
      className={classNames([
        styles.content,
        { [styles.activeContent]: active },
        className,
      ])}
      itemScope
      itemType='https://schema.org/Property'
      {...restProps}
    >
      {children}
    </div>
  );
};

export default TabContent;
